<div>
  Are you sure to update security password on
  <ng-template [ngIf]="!_actionData.bSpecific">
    all the selected devices ?
  </ng-template>
  <ng-template [ngIf]="_actionData.bSpecific">
    device {{ _actionData.deviceList[0].virtualName }} ?
  </ng-template>
</div>
